import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatSliderModule } from '@angular/material/slider'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardSharedUiModule } from 'libs/gb-dashboard/shared/ui/src/lib/gb-dashboard-shared-ui.module'
import { GbTokenColorPickerComponent } from 'libs/gb-dashboard/shared/ui/src/lib/gb-token-color-picker/gb-token-color-picker.component'
import { GbPresenterToolsAdvancedOptionsContainerComponent } from '../gb-presenter-tools-advanced-options-container/gb-presenter-tools-advanced-options-container.component'
import { GbPresenterToolsTextComponent } from '../gb-presenter-tools-text/gb-presenter-tools-text.component'

@Component({
  selector: 'gb-presenter-tools-power-pledge',
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSliderModule,
    TranslateModule,
    GbDashboardSharedUiModule,
    GbTokenColorPickerComponent,
    GbPresenterToolsTextComponent,
    GbPresenterToolsAdvancedOptionsContainerComponent,
  ],
  templateUrl: './gb-presenter-tools-power-pledge.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbPresenterToolsPowerPledgeComponent {
  @Input({ required: true }) toolsFormGroup!: FormGroup

  hideFields = ['font_style', 'font_weight', 'text_align', 'color']

  get rowsControl(): FormControl {
    return this.toolsFormGroup.get('rows') as FormControl
  }

  get tablePrimaryColorControl(): FormControl {
    return this.toolsFormGroup.get('table_primary_color') as FormControl
  }

  get tableAccentColorControl(): FormControl {
    return this.toolsFormGroup.get('table_accent_color') as FormControl
  }

  get firstPlaceColorControl(): FormControl {
    return this.toolsFormGroup.get('first_place_color') as FormControl
  }

  get secondPlaceColorControl(): FormControl {
    return this.toolsFormGroup.get('second_place_color') as FormControl
  }

  get thirdPlaceColorControl(): FormControl {
    return this.toolsFormGroup.get('third_place_color') as FormControl
  }

  get defaultRankColorControl(): FormControl {
    return this.toolsFormGroup.get('default_rank_color') as FormControl
  }

  get opacityControl(): FormControl {
    return this.toolsFormGroup.get('opacity') as FormControl
  }
}
